import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'notificationsTabsTitleTranslate',
})
export class NotificationsTabsTitleTranslatePipe implements PipeTransform {
  transform(title: string): string {
    const translations = {
      Incidents: $localize`:@@common.incident:Incident`,
      Notifications: $localize`:@@common.notifications:Notifications`,
      Master: $localize`:@@common.master:Master`,
      Affiliates: $localize`:@@common.affiliates:Affiliates`,
      Conversions: $localize`:@@common.conversions:Conversions`,
    };
    return translations[title];
  }
}
